import React, { useState } from "react";
import {Collapse,Divider,List,ListItem,ListItemIcon,ListItemText,Typography,useTheme,Tooltip,Menu} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import classnames from "classnames";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
// styles
import useStyles from "./styles";
import { getMuiTheme } from "./styles";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Scrollbars } from 'react-custom-scrollbars';
import {FaIcon} from "../../../";


const initialState = {
  mouseX: null,
  mouseY: null,
};
export default function SidebarLink({
  link,
  icon,
  label,
  children,
  location,
  isSidebarOpened,
  nested,
  type,
  module,
  
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [state, setState] = React.useState(initialState);
  const [toggle, setToggle] = React.useState(false);

  const toggleSubmenu = (event) => {
    setState({
      mouseX: event.clientX - 0,
      mouseY: event.clientY - 7,
    });
    setAnchorEl(event.currentTarget);
  };

  const toggleIcon = (event, link) => {
    setToggle(!toggle);
    toggleCollapse(event, link);
  };

  const handleClose = () => {
    setToggle(!toggle);
    setState(initialState);
    setAnchorEl(null);
  };
  var classes = useStyles();
  const history = useHistory();
  const currentTheme = useTheme();
  var [isOpen, setIsOpen] = useState(false);
  
  let pathValue='';
  //let moduleName='';
  if(link)
  {
    // let linkData = link.split("/");
    // moduleName = (linkData[2])?linkData[2]:'';

    let pathData = location.pathname.split("/");
    pathValue = (pathData[3])?pathData[3]:'';
  }

  var isLinkActive =
    link &&
    (pathValue === module || location.pathname.indexOf(link) !== -1);

  if (type === "title")
    return (
      <Typography
        className={classnames(classes.linkText, classes.sectionTitle,classes.sidebarlinkadj, {
          [classes.linkTextHidden]: !isSidebarOpened,
        })}
      >
        {nested ? (
          <FaIcon icon={`fas ${icon ? icon.icon : "fa-cube"}`} size="1x"/>
          // <i className={`fas ${icon ? icon.icon : "fas fa-cube"} fa-1x`}></i>
        ) : (
          <FaIcon icon={`fas ${icon ? icon.icon : "fa-cube"}`} size="1x"/>
          // <i className={`fas ${icon ? icon.icon : "fas fa-cube"} fa-1x`}></i>
        )}{" "}
        {label}
      </Typography>
    );

  if (type === "divider") return <Divider className={classes.divider} />;

  if (!children)
    return (
      
      <ListItem
        button
        component={link && Link}
        to={link}
        className={classes.link}
        classes={{
          root: classnames(classes.linkRoot, {
            [classes.linkActive]: isLinkActive && !nested,
            [classes.linkNested]: nested,
          }),
        }}
        disableRipple
      >
        
      { icon ?
        <ListItemIcon
          className={classnames(classes.linkIcon,classes.linkiconadj, {
            [classes.linkIconActive]: isLinkActive,
          })}
        >
          {nested ? (
            <FaIcon icon={`fas ${icon ? icon.icon : "fa-cube"}`} size="1x"/>
            // <i className={`fas ${icon ? icon.icon : 'fas fa-cube'} fa-1x`}></i>
          ) : (
            <FaIcon icon={`fas ${icon ? icon.icon : "fa-cube"}`} size="1x"/>
            // <i className={`fas ${icon ? icon.icon : 'fas fa-cube'} fa-1x`}></i>
          )}
        </ListItemIcon>
        : null
      }
        { label ?
          <Tooltip title={label} placement="right-start">
            <ListItemText
              onMouseEnter={(e) => toggleSubmenu(e)}
              classes={{
                primary: classnames(classes.nestedLinkText, {
                  [classes.linkTextActive]: isLinkActive,
                  [classes.linkTextHidden]: !isSidebarOpened,
                }),
              }}
              primary={label}
            />
          </Tooltip> : null
        }
        
      </ListItem>
      
      
    );

  return (
    <>
    <MuiThemeProvider theme={getMuiTheme(currentTheme)}>
      
      <Tooltip title={label} placement="right-end" style={{ marginRight: -10 }}>
        <ListItem
          button
          component={link && Link}
          className={isLinkActive ? classes.linkActive : classes.link}
          to={link}
          disableRipple
        >
          <ListItemIcon
            className={classnames(classes.linkIcon, {
              [classes.isCollapsed]: !isSidebarOpened,
            })}
          >
            {icon && (
              <FaIcon icon={`fas ${icon ? icon.icon : "fa-cube"}`} size="1x"/>
              // <i
              //   style={{ color: "#fff" }}
              //   className={`fas ${icon ? icon.icon : "fas fa-cube"} fa-1x`}
              // />
            )}
          </ListItemIcon>
          
            <ListItemText
              classes={{
                primary: classnames(classes.linkText, {
                  [classes.linkTextActive]: isLinkActive,
                  [classes.linkTextHidden]: !isSidebarOpened,
                }),
              }}
              primary={label}
            />
          {isSidebarOpened?(
          (link !== "/app/Home" && link !== "/app/Emails" && link !== "/app/Calendar") ? (
            toggle ? (
              <ExpandLessIcon color="#fff" />
            ) : (
              <ExpandMoreIcon color="#fff" onClick={(e) => toggleIcon(e, link)} />
            )
          ) : null):""}
        </ListItem>
      </Tooltip>
      {children.length > 0 ? (
        
        <Menu
          id="simple-menu"
          open={state.mouseY !== null}
          onClose={handleClose}
          onClick={() => handleClose()}
          anchorReference="anchorPosition"
          className={classes.nestedList}
          style={{ borderRadius: 0 }}
          anchorOrigin={{ vertical: "center", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          anchorPosition={
            state.mouseY !== null && state.mouseX !== null
              ? { top: state.mouseY + 7, left: isSidebarOpened ? 185 : 80 }
              : undefined
          }
        >
          
          <List component="div" disablePadding>
            <Scrollbars autoHide={true} style={{height:200, width:200}}>
            {children.map((childrenLink) => (

              <SidebarLink
                key={Math.random() + "" + (childrenLink && childrenLink.link)}
                location={location}
                isSidebarOpened={isSidebarOpened}
                classes={classes}
                nested
                {...childrenLink}
              />
            ))}
            </Scrollbars>
          </List>
        </Menu>
        
      ) : (
        ""
      )}
      {/* <List
        component="div"
        disablePadding
        className={classes.nestedList}
        style={{ display: isOpen && isSidebarOpened ? "block" : "none" }}
      >
        {children.map((childrenLink) => (
          <SidebarLink
            key={childrenLink && childrenLink.link}
            location={location}
            isSidebarOpened={isSidebarOpened}
            classes={classes}
            nested
            {...childrenLink}
          />
        ))}
      </List> */}
      {!children && (
        <Collapse
          in={isOpen && isSidebarOpened}
          timeout="auto"
          unmountOnExit
          className={classes.nestedList}
        >
          <List component="div" disablePadding>
            {children.map((childrenLink) => (
              <SidebarLink
                key={childrenLink && childrenLink.link}
                location={location}
                isSidebarOpened={isSidebarOpened}
                classes={classes}
                nested
                {...childrenLink}
              />
            ))}
          </List>
        </Collapse>
      )}
      </MuiThemeProvider>
    </>
  );

  function toggleCollapse(e, lnk) {
    e.preventDefault();
    handleClose();
    setState({
      mouseX: e.clientX - 0,
      mouseY: e.clientY - 7,
    });
    setAnchorEl(e.currentTarget);

    if (isSidebarOpened) {
      e.preventDefault();
      setIsOpen(!isOpen);

      if (nested) history.push(lnk);

      if (lnk === "/app/Home") history.push("/app/dashboard");
      //handleClose();
    }
  }
}
